<template>
  <div>
    <el-dialog
      class="dialog"
      title="让我们共同探索生命科学领域的自动化未来"
      :visible.sync="dialogFormVisible"
      :before-close="handleClose"
      append-to-body
    >
      <div class="box_left">
        <el-form :label-position="labelPosition" :model="form" ref="contactForm" :rules="rules">
          <el-form-item label="怎么称呼您？" prop="username" :label-width="formLabelWidth">
            <el-input v-model="form.username" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="您所在公司/组织？" prop="organization" :label-width="formLabelWidth">
            <el-input v-model="form.organization" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="您的职务是？" prop="job" :label-width="formLabelWidth">
            <el-input v-model="form.job" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="如何回复您？" prop="contact" :label-width="formLabelWidth">
            <div style="display: flex">
              <el-select v-model="form.contact">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-input v-model="form.contactInfo" prop="contactInfo" placeholder="请输入"></el-input>
            </div>
          </el-form-item>
        </el-form>
        <div class="form_bottom">
          <div class="head">您期望了解的产品（多选）</div>
          <div class="check_title">
            <div class="labels">
              <div>水星计划</div>
              <div class="label_text">诊断</div>
              <div>生物工程</div>
            </div>
            <el-checkbox-group v-model="checkList">
              <el-row :gutter="50">
                <el-col :span="6"><el-checkbox label="水星实验室"></el-checkbox></el-col>
                <el-col :span="6"><el-checkbox label="CDMO服务"></el-checkbox></el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="6"><el-checkbox label="Combo-E"></el-checkbox></el-col>
                <el-col :span="6"><el-checkbox label="Combo-Q"></el-checkbox></el-col>
                <el-col :span="6"><el-checkbox label="Combo-G"></el-checkbox></el-col>
                <el-col :span="6"><el-checkbox label="Combo-M"></el-checkbox></el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="6"><el-checkbox label="Flex-SC"></el-checkbox></el-col>
                <el-col :span="6"><el-checkbox label="Flex-CG"></el-checkbox></el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="6"><el-checkbox label="ACE Mini96"></el-checkbox></el-col>
                <el-col :span="6"><el-checkbox label="ACE ATP192"></el-checkbox></el-col>
                <el-col :span="6"><el-checkbox label="ACE Line"></el-checkbox></el-col>
                <el-col :span="6"><el-checkbox label="Lib Master"></el-checkbox></el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :span="6"><el-checkbox label="Lib FLOW"></el-checkbox></el-col>
                <el-col :span="6"><el-checkbox label="QC Master"></el-checkbox></el-col>
                <el-col :span="6"><el-checkbox label="Lab Net"></el-checkbox></el-col>
              </el-row>
            </el-checkbox-group>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" class="btn_dialog" @click="onSubmitDebounced">发送消息</el-button>
        </div>
      </div>
      <div class="box_right">
        <div class="title">其他联系方式</div>
        <div class="subtitle">销售咨询热线</div>
        <div class="box_text phone">
          <img src="@/assets/img/contact/phone.svg" alt="" />
          <span>0755-21006210</span>
        </div>
        <div class="box_text">
          <img src="@/assets/img/contact/alarm.svg" alt="" />
          <span>7天*24h</span>
        </div>
        <div class="subtitle">邮箱</div>
        <div class="box_text">
          <img src="@/assets/img/contact/mail.svg" alt="" />
          <span>service@cladogram.com</span>
        </div>
        <div class="subtitle">企业微信</div>
        <div>
          <img src="@/assets/img/contact/weixin.jpg" alt="" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { save } from '@/api/api';
import { debounce } from 'lodash';
export default {
  name: 'CommonDialog',
  components: {},
  props: {
    dialogFormVisible: {
      default: false
    }
  },
  data() {
    return {
      visible: false,
      labelPosition: 'top',
      form: {
        username: '',
        organization: '',
        job: '',
        contact: '',
        contactInfo: ''
      },
      rules: {
        username: [{ required: true, message: '请输入您的姓名', trigger: 'blur' }],
        contact: [{ required: true, message: '请选择联系方式类型', trigger: 'change' }],
        contactInfo: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        organization: [{ required: true, message: '请输入所在公司/组织', trigger: 'blur' }]
      },
      formLabelWidth: '120px',
      checkList: [],
      options: [
        {
          value: 'phone',
          label: '手机'
        },
        {
          value: 'email',
          label: '邮箱'
        },
        {
          value: 'weChat',
          label: '微信'
        }
      ],
      value: ''
    };
  },
  methods: {
    handleClose() {
      this.$emit('update:dialogFormVisible', false);
    },
    onSubmitDebounced: debounce(function() {
      this.onSubmit();
    }, 1000),
  
    onSubmit() {
      this.$refs['contactForm'].validate(valid => {
        if (valid) {
          save({ ...this.form, productList: this.checkList })
            .then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '信息提交成功！',
                  type: 'success'
                });
                this.dialogFormVisible = false;
              } else {
                this.$message.error('网络错误');
              }
            })
            .catch(err => console.log(2, err));
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.box_left {
  padding: 24px 40px 24px 40px;
  width: 716px;
  border-radius: 4px;
}

.box_right {
  display: inline;
  width: 280px;
  background: rgba(245, 245, 247, 1);
  padding: 220px 20px 35px 20px;
}

/deep/ .el-dialog {
  border-radius: 4px;
  width: 996px;
  margin-top: 74px !important;
}

/deep/ .el-select {
  margin-right: 10px;
}

/deep/ .el-form--label-top .el-form-item__label {
  padding: 0;
}

/deep/ .el-form-item {
  width: 400px;
  margin-bottom: 16px;
}

/deep/.el-form-item__label {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: flex-end;
  color: #112448;
}

/deep/ .el-checkbox__label {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #112448;
}

/deep/ .el-input__inner {
  color: #112448;
  font-weight: 500;
}

.title {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #112448;
}

.subtitle {
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #009aef;
  margin-bottom: 20px;
  margin-top: 36px;
}

.box_text {
  display: flex;
  align-items: center;
  font-size: 14px;
  span {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    color: #112448;
  }
  img {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
}

.phone {
  margin-bottom: 24px;
}

/deep/ .el-form-item__content {
  height: 40px;
}

/deep/.el-dialog__header {
  padding: 16px 24px 16px 24px !important;
}

/deep/ .el-dialog__body {
  display: flex;
  padding: 0 !important;
  justify-content: space-between;
}

/deep/ .el-form {
  padding: 24px 40px 24px 40px !important;
}

.form_bottom {
  .head {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #112448;
  }

  .check_title {
    display: flex;
    margin-top: 16px;
  }

  .el-row {
    height: 16px;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .labels {
    display: flex;
    flex-direction: column;
    height: 200px;
    width: 84px;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;

    color: #009aef;

    .label_text {
      margin-bottom: 56px;
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pc/dialog/index.vue